import React from 'react';
import { Flame, Shield, Sparkle, Zap } from 'lucide-react';
import { EMPOWERED_EVOCATION_FEATURE_ID, OVERCHANNEL_FEATURE_ID, POTENT_CANTRIP_FEATURE_ID, SCULPT_SPELLS_FEATURE_ID } from '../../../shared/rules/subclasses/wizard/evoker.mjs';
import { overchannelUses } from '../../../shared/rules/wizard.mjs';
import { hasSubclassFeature } from '../../../shared/rules/subclasses/index.mjs';
import { isIncapacitated } from '../../../shared/rules/barbarianRage.mjs';
import { notify } from '../../../utils/notification';

/**
 * Reminder tiles for the Evoker features that work on their own, like the other classes' passive tiles. Overchannel
 * shows the backlash its next use would cost.
 */
export const wizardPassiveTiles = (form, characterId, combatState) => {
  const lit = !isIncapacitated({ ...(form || {}), combatantId: String(characterId) }, combatState || {});
  const uses = overchannelUses(form);
  return [
    hasSubclassFeature(form, POTENT_CANTRIP_FEATURE_ID) && { id: 'potent-cantrip', name: 'Potent Cantrip', Icon: Sparkle, accent: '#ffb86b', lit, value: 'Half',
      about: 'A creature that dodges your cantrip, by a miss or a successful save, still takes half its damage.' },
    hasSubclassFeature(form, SCULPT_SPELLS_FEATURE_ID) && { id: 'sculpt-spells', name: 'Sculpt Spells', Icon: Shield, accent: '#9ad1a0', lit, value: '1 + level',
      about: 'When you cast an Evocation area spell, you can choose 1 plus the spell’s level creatures to leave unharmed.' },
    hasSubclassFeature(form, EMPOWERED_EVOCATION_FEATURE_ID) && { id: 'empowered-evocation', name: 'Empowered Evocation', Icon: Flame, accent: '#ff9e9e', lit, value: '+Int',
      about: 'You add your Intelligence modifier to one damage roll of a Wizard Evocation spell.' },
    hasSubclassFeature(form, OVERCHANNEL_FEATURE_ID) && { id: 'overchannel', name: 'Overchannel', Icon: Zap, accent: '#c9b6ff', lit, value: uses ? `${uses + 1}d12 × level` : 'Safe',
      about: uses ? `Your next Overchannel deals you ${uses + 1}d12 Necrotic damage per slot level.` : 'Your first Overchannel before a Long Rest has no cost.' },
  ].filter(Boolean);
};

export default function WizardPassiveTiles({ form, characterId, combatState }) {
  const tiles = wizardPassiveTiles(form, characterId, combatState);
  if (!tiles.length) return null;
  return <>{tiles.map(({ id, name, Icon, accent, lit, value, about }) => (
    <button key={id} type="button" data-action-tile={`wizard:${id}`} aria-label={`${name}: ${lit ? 'active' : 'inactive'}`} title={about}
      className={`combat-hud-resource-tile combat-hud-feature-action-tile combat-hud-resource-tile--passive${lit ? '' : ' combat-hud-resource-tile--dormant'}`}
      style={{ '--hud-resource-accent': accent }} onClick={() => notify(`${name}: ${about}`, 'info')}>
      <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Icon size={20}/></span>
      <span className="combat-hud-resource-tile__name">{name}</span>
      <span className="combat-hud-resource-tile__value">{value}</span>
    </button>
  ))}</>;
}
